export default __webpack_public_path__ + "static/media/NIAS0040.34I-27375_-16940_0.069ccf00.jpg";